import React from 'react'



const Header = () => {
  return (
    <header className="header">
      <h1>Distillery Map</h1>
    </header>

  )
}

export default Header
